<script setup lang="ts">
import LinkDetailPage from '../features/links/LinkDetailPage.vue';

const props = defineProps<{
  id: string | number;
}>();
</script>

<template>
  <LinkDetailPage :id="props.id" />
</template>
